import { Ideas } from "./ArchivioIdeeDiBusiness";
export default Ideas;
